import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const mediaUrl = (u) => {
  if (!u) return undefined;
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u}`;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Facebook-group migration funnel: capture referral code + UTM from URL and persist
export function captureFunnelFromUrl() {
  const p = new URLSearchParams(window.location.search);
  const ref = p.get("ref");
  const src = p.get("utm_source");
  const camp = p.get("utm_campaign");
  if (ref) localStorage.setItem("dona_ref", ref);
  if (src) localStorage.setItem("dona_utm_source", src);
  if (camp) localStorage.setItem("dona_utm_campaign", camp);
}

export function getFunnelData() {
  return {
    referral_code: localStorage.getItem("dona_ref") || undefined,
    utm_source: localStorage.getItem("dona_utm_source") || undefined,
    utm_campaign: localStorage.getItem("dona_utm_campaign") || undefined,
  };
}

export function clearFunnelData() {
  localStorage.removeItem("dona_ref");
  localStorage.removeItem("dona_utm_source");
  localStorage.removeItem("dona_utm_campaign");
}
